export function isEmptyHTML(s: string) {
  const body = new DOMParser().parseFromString(s, "text/html")?.body;

  let children = Array.from(body?.children ?? []);
  let next: Element[] = [];

  while (children.length) {
    for (const child of children) {
      if (child.textContent) return false;
      for (const node of child.children) next.push(node);
    }

    children = [...next];
    next = [];
  }

  return true;
}
